import { Link } from "react-router-dom"
import MainImage from "../assets/landing-main-image.png"
import Bracket from "../assets/bracket.png"
import { useEffect, useState } from "react"
import Slider from "react-slick";
import { RiPhpLine } from "react-icons/ri";
import MatrixAnimation from "../components/MatrixAnimation";
import axios from "axios";
import "../components/matrix.css"; // سبک‌ها را جدا در فایل CSS قرار می‌دهیم
import { FaReact } from "react-icons/fa6";
import { LuBrainCircuit } from "react-icons/lu";
import { SiAndroidstudio } from "react-icons/si";
import { SiKalilinux } from "react-icons/si";
import { FaUnity } from "react-icons/fa";
import { Helmet } from "react-helmet";

export const Home = ()=>{
    return (
        <MatrixAnimation DotsColor={"100, 100, 100"} maxDotCount = {100}>
        <div className="w-full">
        <Helmet>
        <title>نقشه راه برنامه نویسی | کندو</title>
        <meta name="description" content="پیدا کردن نقشه راه برنامه نویسی اولین قدم در شروع یادگیری برنامه نویسی میباشد که بسیار اهمیت است" />
        </Helmet>
        <header className="w-full min-h-[50vh] flex my-10">
          <div className="w-full flex flex-col items-center justify-center">
            <h1 dir = "rtl" className="text-white text-center leading-[65px] font-main font-normal text-3xl">
            نقشه راه <em className="text-blue-500 font-black text-5xl">برنامه‌نویسی</em> : مسیر خود را به سمت موفقیت پیدا کنید!
            </h1>
            <p className="text-gray-300 font-main font-light text-base text-center w-11/12 lg:w-2/4 mt-10 leading-10" dir = "rtl">
            برای ورود به دنیای برنامه‌نویسی و رسیدن به اهداف خود، داشتن یک نقشه راه دقیق ضروری است. ما در کندو با ارائه مسیرهای یادگیری گام‌به‌گام، به شما کمک می‌کنیم تا بهترین مسیر را برای یادگیری و پیشرفت انتخاب کنید. فرقی نمی‌کند مبتدی باشید یا حرفه‌ای، این نقشه‌ها ابزار شما برای دستیابی به موفقیت هستند.
            </p>
          </div>
        </header>
        
        <div className="w-full my-10 text-center flex items-center justify-center flex-col text-white font-main gap-10">
          <h2 className="text-4xl">
            نقشه راه مورد نظرت رو انتخاب کن
          </h2>
          <p>
            میتوانی هرکدام از نقشه راه هایی که دوست داری را انتخاب کنی
          </p>
        </div>
        <div className="w-full my-10 flex flex-row-reverse flex-wrap justify-center items-center gap-5">
          <Link to = "/backend" className="transition-all cursor-pointer hover:bg-[#4d508e] w-48 h-48 bg-hivoo-light gap-5 rounded-xl text-center flex items-center justify-center flex-col">
            <RiPhpLine className="text-7xl text-gray-300 group-hover:text-orange-400"/>
            <span className="font-main text-gray-300 group-hover:text-orange-400">
              نقشه راه بک اند
            </span>
          </Link>  
          <Link to = "/frontend" className="group transition-all cursor-pointer hover:bg-[#1fcbe6] w-48 h-48 gap-5 bg-hivoo-light rounded-xl text-center flex items-center justify-center flex-col">
            <FaReact className="text-7xl transition-all text-gray-300 group-hover:text-gray-800"/>
            <span className="font-main transition-all text-gray-300 group-hover:text-gray-800">
              نقشه راه فرانت اند
            </span>
          </Link>
          <Link to = "/ai" className="group transition-all cursor-pointer hover:bg-rose-700 w-48 gap-5 h-48 bg-hivoo-light rounded-xl text-center flex items-center justify-center flex-col">
            <LuBrainCircuit className="text-7xl transition-all text-gray-300 "/>
            <span className="font-main transition-all text-gray-300">
              هوش مصنوعی
            </span>
          </Link>  

          <Link to = "/mobile" className="group transition-all cursor-pointer hover:bg-[#55b662] w-48 h-48 bg-hivoo-light rounded-xl text-center flex items-center justify-center gap-5 flex-col">
            <SiAndroidstudio className="text-7xl transition-all text-gray-300 group-hover:text-gray-800"/>
            <span className="font-main transition-all text-gray-300 group-hover:text-gray-800">
                اپلیکیشن موبایل
            </span>
          </Link>
          {/* <Link to = "/roadmap/gamedevelopment" className="group transition-all cursor-pointer hover:bg-[#484848] w-48 h-48 bg-hivoo-light rounded-xl text-center flex items-center justify-center gap-5 flex-col">
            <FaUnity className="text-7xl transition-all text-gray-300 "/>
            <span className="font-main transition-all text-gray-300 ">
                بازی سازی
            </span>
          </Link> */}
          <Link to = "/security" className="group transition-all cursor-pointer hover:bg-[#124dc7] w-48 h-48 bg-hivoo-light rounded-xl text-center flex items-center justify-center gap-5 flex-col">
            <SiKalilinux className="text-7xl transition-all text-gray-300 "/>
            <span className="font-main transition-all text-gray-300 ">
                هک و امنیت
            </span>
          </Link>
        </div>
      </div>
      </MatrixAnimation>
    )
}


